import { render, staticRenderFns } from "./International3.vue?vue&type=template&id=72899e6c&scoped=true"
import script from "./International3.vue?vue&type=script&lang=js"
export * from "./International3.vue?vue&type=script&lang=js"
import style0 from "./International3.vue?vue&type=style&index=0&id=72899e6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72899e6c",
  null
  
)

export default component.exports